export type TitleTableUsers =
    | {
        name: string
        field: string
        sort: boolean
        first: boolean
        last?: undefined
    }
    | {
        name: string
        field: string
        sort: boolean
        first?: undefined
        last?: undefined
    }
    | {
        name: string
        field: string
        sort: boolean
        last: boolean
        first?: undefined
    }
const titleTableUsers: TitleTableUsers[] = [
    { name: 'Usuário', field: 'u_user', sort: true, first: true },
    { name: 'Perfil', field: 'u_profile', sort: false },
    { name: 'Unidade e Setor', field: 'u_location_and_sector', sort: false },
    // { name: 'Unidade', field: 'u_location', sort: true },
    // { name: 'Setor', field: 'u_sector', sort: true },
    { name: 'E-mail', field: 'u_user.email', sort: true },
    { name: 'Status', field: 'u_active', sort: true, last: true }
]

const titleTableSectors = [
    { name: 'Setor', field: 'u_name', sort: true, first: true },
    {
        name: 'Inativo em Unidades',
        field: 'u_count_inactive',
        sort: false,
        last: true
    },
    { name: 'Ativo em Unidades', field: 'u_count_active', sort: false },
]

const titleTableSectorsPerUnit = [
    {
        name: 'Unidade',
        field: 'x_rdsls_notificabe_locations',
        sort: true,
        first: true
    },
    { name: 'Gestor', field: '', sort: false, first: true },
    { name: 'Status do setor na Unidade', field: '', sort: false, last: true }
]

export { titleTableUsers, titleTableSectors, titleTableSectorsPerUnit }
